import axios from 'axios';
import {
	GET_CLI_USERS,
	GET_CLI_USERS_SUCCESS,
	GET_CLI_USERS_FAIL,
	DELETE_CLI_USERS,
	DELETE_CLI_USERS_SUCCESS,
	DELETE_CLI_USERS_FAIL,
	ADD_CLI_USERS,
	ADD_CLI_USERS_COMPLETE,
	EDIT_CLI_USERS,
	EDIT_CLI_USERS_COMPLETE,
	GET_GROUP_CONFIGURATION,
	GET_GROUP_CONFIGURATION_SUCCESS,
	GET_GROUP_CONFIGURATION_FAIL,
	UPDATE_GROUP_CONFIGURATION,
	UPDATE_GROUP_CONFIGURATION_COMPLETE,
	UPDATE_ACCESS_POINT_NAME,
	UPDATE_ACCESS_POINT_NAME_COMPLETE,
	GET_AP_NAME,
	GET_AP_NAME_SUCCESS,
	GET_AP_NAME_FAIL,
	GET_INTERFACE_LIST_FAIL,
	GET_INTERFACE_LIST,
	GET_INTERFACE_LIST_SUCCESS,
	UPDATE_TIP_CONFIG,
	UPDATE_TIP_CONFIG_SUCCESS,
	UPDATE_TIP_CONFIG_ERROR,
	GET_TIP_CONFIG,
	GET_TIP_CONFIG_SUCCESS,
	GET_TIP_CONFIG_FAIL,
	UPDATE_LAN_WAN_TIP_CONFIG,
	UPDATE_LAN_WAN_TIP_CONFIG_SUCCESS,
	UPDATE_LAN_WAN_TIP_CONFIG_FAIL,
	GET_GROUP_INFO,
	GET_GROUP_INFO_SUCCESS,
	GET_GROUP_INFO_FAIL,
	GET_ROGUE_AP_LIST,
	GET_ROGUE_AP_LIST_SUCCESS,
	GET_ROGUE_AP_LIST_FAIL,
	GET_TIP_AP_CONFIG_SUCCESS,
	GET_TIP_AP_CONFIG,
	GET_TIP_AP_CONFIG_FAIL,
	UPDATE_TIP_AP_CONFIG_FAIL,
	DELETE_KNOWN_ROGUE,
	DELETE_KNOWN_ROGUE_SUCCESS,
	DELETE_KNOWN_ROGUE_FAIL,
	MOVE_TO_KWOWN_ROGUE,
	MOVE_TO_KWOWN_ROGUE_SUCCESS,
	MOVE_TO_KWOWN_ROGUE_FAIL,
	BULK_UPLOAD_KNOWN,
	BULK_UPLOAD_KNOWN_SUCCESS,
	BULK_UPLOAD_KNOWN_FAIL,
	UPDATE_TIP_AP_CONFIG_SUCCESS,
	GET_SWITCH_TOPOLOGY,
	GET_SWITCH_TOPOLOGY_SUCCESS,
	GET_SWITCH_TOPOLOGY_FAILURE,
	ROGUE_WIFI_SCAN,
	ROGUE_WIFI_SCAN_SUCCESS,
	ROGUE_WIFI_SCAN_FAIL,
	GET_AP_GROUP_INFO,
	GET_AP_GROUP_INFO_SUCCESS,
	GET_AP_GROUP_INFO_FAIL,
} from '../../constants/groupConfigurationConstants/groupConfigurationConstants';

import {
	ENDPOINT_URL,
	GET_CLI_USERS_LIST,
	TOKEN_FAILED,
	POST_API_RESPONSE_SUCCESS_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	// AUTH_TOKEN_ERROR_STATUS_MSG,
	DELETE_CLI_USERS_API,
	ADD_CLI_USERS_API,
	EDIT_CLI_USERS_API,
	GET_GROUP_CONFIGURATION_API,
	UPDATE_GROUP_CONFIGURATION_API,
	UPDATE_ACCESS_POINT_API,
	GET_EACH_ACCESS_POINT_API,
	GET_INTERFACE_LIST_API,
	TIP_CONFIGURATION_UPDATE,
	TIP_CONFIGURATION_RETRIEVE,
	LAN_WAN_TIP_CONFIGURATION_UPDATE,
	GET_ROGUE_ACCESS_POINT_API,
	GET_EACH_TIP_AP_CONFIG,
	UPDATE_EACH_TIP_AP_CONFIG,
	UPDATE_EACH_TIP_IP_AP_CONFIG,
	ROGUE_KNOWN_DELETE,
	TRUST_ROGUE_TO_KNOWN,
	BULK_KNOWN_ROGUE,
	API_SUCCESS_CODES,
	GET_SWITCH_TOPOLOGY_API,
	SCAN_TIP_ROGUE_AP,
	API_RESPONSE_SUCCESS_STATUS_CODE,
} from '../../constants/commonConstants';
import { logout } from '../userActions';
import { decryptData, encryptData } from '../../utils/crypto';
import {
	getGroupCongigAndUpdateAprecom,
	notifyRouterToAprecom,
} from '../apiToNotifyAprecom';
// import { logout } from './userActions';

/**
 * Action creator for listing client cli.
 *
 * This function asynchronously dispatches actions to fetch a list of client cli Entries.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {number} [limit=50] - Optional parameter specifying the maximum number of client cli entries to fetch.
 * @param {number} [offset=0] - Optional parameter specifying the page no. to fetch the entries from that particular page.
 * @param {string} [siteId] - required parameter specifying the site Id of slected group
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const listClientCli =
	(limit = 50, offset = 0, siteId) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_CLI_USERS,
			});

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL +
					GET_CLI_USERS_LIST +
					siteId +
					'/?limit=' +
					limit +
					'&offset=' +
					offset,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if (data && data.results) {
				dispatch({
					type: GET_CLI_USERS_SUCCESS,
					payload: data,
				});
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GET_CLI_USERS_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GET_CLI_USERS_FAIL,
				payload: 'Error fetching CLIENT CLI LIST',
			});
		}
	};

/**
 * Action for making an API call to delete specidied CLI_USERS entries.
 *
 * @param {object} deleteArray - Array of CLI_USERS ids to be deleted
 * @param {string} siteId - required parameter specifying the site Id of slected group
 * @return {Promise} - A promise that resolves with the deleted CLI_USERS data.
 */
export const deleteClientCli =
	(deleteArray, siteId) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: DELETE_CLI_USERS,
			});

			const jsonData = JSON.stringify(deleteArray);
			const ciphertext = encryptData(jsonData);
			// Configure request
			const config = {
				method: 'put',
			url: ENDPOINT_URL + DELETE_CLI_USERS_API + siteId + '/',
			data: ciphertext,
		};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			// Dispatch success action with received data
			dispatch({
				type: DELETE_CLI_USERS_SUCCESS,
				payload: data,
			});
			return data;
		} catch (error) {
			// Handle error
			console.error('Failed to update user profile:', error);
			dispatch({
				type: DELETE_CLI_USERS_FAIL,
				payload: error.message || 'Failed to delete client cli entries',
			});
			// throw error;
			return error;
		}
	};

export const addClientCli = (payload, siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: ADD_CLI_USERS,
		});

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
			maxBodyLength: Infinity,
		url: ENDPOINT_URL + ADD_CLI_USERS_API + siteId + '/',
		data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if (
			data &&
			data.status &&
			data.status === POST_API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			dispatch({
				type: ADD_CLI_USERS_COMPLETE,
				payload: data,
			});
			return data;
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: ADD_CLI_USERS_COMPLETE,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (data?.error) {
			dispatch({
				type: ADD_CLI_USERS_COMPLETE,
				payload: data,
			});
			return data;
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: ADD_CLI_USERS_COMPLETE,
			payload: message,
		});
		return error;
	}
};

/**
 * Action for making an API call to edit CLI_USERS data.
 *
 * @param {object} updatePayload - Object contains profile name, client cli, description
 * @param {string} siteId - unique id to recognise the group
 * @param {string} uniqueUser - username of the client to be edited
 * @return {Promise} - A promise that resolves with the deleted CLI_USERS data.
 */
export const editClientCli =
	(updatePayload, siteId, uniqueUser) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: EDIT_CLI_USERS,
			});

			// Configure request
			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				url: ENDPOINT_URL +
					EDIT_CLI_USERS_API +
					siteId +
					'/' +
				uniqueUser +
				'/',
			data: ciphertext,
		};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			// Dispatch success action with received data
			dispatch({
				type: EDIT_CLI_USERS_COMPLETE,
				payload: data,
			});
			return data;
		} catch (error) {
			// Handle error
			console.error('Failed to edit data', error);
			dispatch({
				type: EDIT_CLI_USERS_COMPLETE,
				payload: error.message || 'Failed to edit data',
			});
			return error;
		}
	};

/**
 * Action creator for listing client cli.
 *
 * This function asynchronously dispatches actions to fetch a list of client cli Entries.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {string} [siteId] - required parameter specifying the site Id of slected group
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getGroupCongigData = (siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_GROUP_CONFIGURATION,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_GROUP_CONFIGURATION_API + siteId + '/',
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if (data && data.data && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: GET_GROUP_CONFIGURATION_SUCCESS,
				payload: data,
			});
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_GROUP_CONFIGURATION_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
			return
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GET_GROUP_CONFIGURATION_FAIL,
			payload: 'Error fetching site configuration',
		});
		return message;
	}
};

/**
 * Action for making an API call to edit CLI_USERS data.
 * @param {object} updatePayload - Object contains profile name, client cli, description
 * @param {string} siteId - unique id to recognise the group
 * @param {object} oldSiteName
 * @param {object} oldNestedSiteName
 * @return {Promise} - A promise that resolves with the deleted CLI_USERS data.
 */
export const updateGroupConfiguration =
	(updatePayload, siteId, oldSiteName, oldNestedSiteName) =>
	async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: UPDATE_GROUP_CONFIGURATION,
			});

			// Configure request
			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				url: ENDPOINT_URL +
				UPDATE_GROUP_CONFIGURATION_API +
				siteId +
				'/',
			data: ciphertext,
		};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			// Dispatch success action with received data
			dispatch({
				type: UPDATE_GROUP_CONFIGURATION_COMPLETE,
				payload: data,
			});
			dispatch(
				getGroupCongigAndUpdateAprecom({
					oldNestedSiteName: oldNestedSiteName,
					siteId,
				})
			);
			return data;
		} catch (error) {
			// Handle error
			console.error('Failed to edit data', error);
			dispatch({
				type: UPDATE_GROUP_CONFIGURATION_COMPLETE,
				payload: error.message || 'Failed to edit data',
			});
			return error;
		}
	};

/**
 * Action for making an API call to edit CLI_USERS data.
 *
 * @param {object} updatePayload - Object contains profile name, client cli, description
 * @param {string} siteId - unique id to recognise the group
 * @return {Promise} - A promise that resolves with the deleted CLI_USERS data.
 */
export const updateAccessPointName =
	(updatePayload, siteId) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: UPDATE_ACCESS_POINT_NAME,
			});

			// Configure request
			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
			method: 'patch',
			url: ENDPOINT_URL + UPDATE_ACCESS_POINT_API + siteId + '/',
			data: ciphertext,
		};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			// Dispatch success action with received data
			dispatch({
				type: UPDATE_ACCESS_POINT_NAME_COMPLETE,
				payload: data,
			});
			// need to notify the apprecom about the router name changes.
			if (data?.data?.serial_no) {
				const apprecomPayload = {
					serialList: [{ serialNumber: data?.data?.serial_no }],
					siteName: data?.data?.siteName,
					routerName: updatePayload?.ap_name,
				};
				dispatch(notifyRouterToAprecom(apprecomPayload));
			}
			return data;
		} catch (error) {
			// Handle error
			console.error('Failed to edit data', error);
			dispatch({
				type: UPDATE_ACCESS_POINT_NAME_COMPLETE,
				payload: error.message || 'Failed to edit data',
			});
			return error;
		}
	};

/**
 * Action creator for listing client cli.
 *
 * This function asynchronously dispatches actions to fetch a list of client cli Entries.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {string} [serialNumber] - required parameter specifying the serial number of slected group
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getAPName = (serialNumber) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_AP_NAME,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_EACH_ACCESS_POINT_API + serialNumber + '/',
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data--->', data);

		if (data && data.data) {
			dispatch({
				type: GET_AP_NAME_SUCCESS,
				payload: data,
			});
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_AP_NAME_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
		return data;
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GET_GROUP_CONFIGURATION_FAIL,
			payload: 'Error fetching group configuration',
		});
	}
};

export const getTipApConfig = (serialNumber) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_TIP_AP_CONFIG,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_EACH_TIP_AP_CONFIG + serialNumber + '/',
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data tip--->', data);

		if (data && data.data) {
			dispatch({
				type: GET_TIP_AP_CONFIG_SUCCESS,
				payload: data?.data,
			});
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_TIP_AP_CONFIG_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GET_TIP_AP_CONFIG_FAIL,
			payload: 'Error fetching Tip AP Config',
		});
	}
};

export const updateTipApConfig =
	(id, updatePayload) => async (dispatch, getState) => {
		try {
			dispatch({
				type: UPDATE_TIP_CONFIG,
			});

			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				url: ENDPOINT_URL + UPDATE_EACH_TIP_AP_CONFIG + id + '/',
				data: ciphertext,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (data?.status === 200) {
				dispatch({
					type: UPDATE_TIP_AP_CONFIG_SUCCESS,
					payload: data.data,
				});
				return data;
			} else {
				dispatch({
					type: UPDATE_TIP_AP_CONFIG_FAIL,
					payload: data.msg,
				});
				return data;
			}
		} catch (error) {
			// Handle error
			console.error('Failed to update tip data', error);
			dispatch({
				type: UPDATE_TIP_AP_CONFIG_FAIL,
				payload: error.message || 'Failed to update tip data',
			});
			return error;
		}
	};

export const updateTipApIpConfig =
	(id, updatePayload) => async (dispatch, getState) => {
		try {
			dispatch({
				type: UPDATE_TIP_CONFIG,
			});

			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				url: ENDPOINT_URL + UPDATE_EACH_TIP_IP_AP_CONFIG + id + '/',
				data: ciphertext,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (data?.status === 200) {
				dispatch({
					type: UPDATE_TIP_AP_CONFIG_SUCCESS,
					payload: data.data,
				});
				return data;
			} else {
				dispatch({
					type: UPDATE_TIP_AP_CONFIG_FAIL,
					payload: data.msg,
				});
				return data;
			}
		} catch (error) {
			// Handle error
			console.error('Failed to update tip data', error);
			dispatch({
				type: UPDATE_TIP_AP_CONFIG_FAIL,
				payload: error.message || 'Failed to update tip data',
			});
			return error;
		}
	};
/**
 * Action creator for listing LAN-WAN Interfaces.
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getInterfaceList = () => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_INTERFACE_LIST,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_INTERFACE_LIST_API,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data--->', data);

		if (data && data.data) {
			dispatch({
				type: GET_INTERFACE_LIST_SUCCESS,
				payload: data,
			});
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_INTERFACE_LIST_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GET_GROUP_CONFIGURATION_FAIL,
			payload: 'Error fetching group configuration',
		});
	}
};

export const updateTipConfig =
	(updatePayload, siteId, isGet) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: UPDATE_TIP_CONFIG,
			});

			// Configure request
			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: isGet ? 'get' : 'patch',
				url: ENDPOINT_URL + TIP_CONFIGURATION_UPDATE + siteId + '/',
				...(isGet ? {} : { data: ciphertext }),
			};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (data?.status === 200) {
				dispatch({
					type: UPDATE_TIP_CONFIG_SUCCESS,
					payload: data.data,
				});
				return data;
			} else {
				dispatch({
					type: UPDATE_TIP_CONFIG_ERROR,
					payload: data.msg,
				});
				return data;
			}
		} catch (error) {
			// Handle error
			console.error('Failed to edit data', error);
			dispatch({
				type: UPDATE_TIP_CONFIG_ERROR,
				payload: error.message || 'Failed to edit data',
			});
			return error;
		}
	};

export const retrieveTipConfig =
	(updatePayload, siteId, isGet) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: GET_TIP_CONFIG,
			});

			// Configure request
			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: isGet ? 'get' : 'patch',
				url: ENDPOINT_URL + TIP_CONFIGURATION_RETRIEVE + siteId + '/',
				...(isGet ? {} : { data: ciphertext }),
			};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (data?.status === 200) {
				dispatch({
					type: GET_TIP_CONFIG_SUCCESS,
					payload: data.data,
				});
				return data;
			} else {
				dispatch({
					type: GET_TIP_CONFIG_FAIL,
					payload: data.msg,
				});
				return data;
			}
		} catch (error) {
			// Handle error
			console.error('Failed to retrieve tip data', error);
			dispatch({
				type: GET_TIP_CONFIG_FAIL,
				payload: error.message || 'Failed to retrieve tip data',
			});
			return error;
		}
	};
export const updateLanWanTipConfig =
	(updatePayload, id) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: UPDATE_LAN_WAN_TIP_CONFIG,
			});

			// Configure request
			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				url: ENDPOINT_URL + LAN_WAN_TIP_CONFIGURATION_UPDATE + id + '/',
				data: ciphertext,
			};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (data?.status === 200) {
				dispatch({
					type: UPDATE_LAN_WAN_TIP_CONFIG_SUCCESS,
					payload: data.data,
				});
				return data;
			} else {
				dispatch({
					type: UPDATE_LAN_WAN_TIP_CONFIG_FAIL,
					payload: data.msg,
				});
				return data;
			}
		} catch (error) {
			// Handle error
			console.error('Failed to update tip data', error);
			dispatch({
				type: UPDATE_LAN_WAN_TIP_CONFIG_FAIL,
				payload: error.message || 'Failed to update tip data',
			});
			return error;
		}
	};

/**
 * Action creator for listing client cli.
 *
 * This function asynchronously dispatches actions to fetch a list of client cli Entries.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {string} [siteId] - required parameter specifying the site Id of slected group
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getGroupInfo = (siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_GROUP_INFO,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_GROUP_CONFIGURATION_API + siteId + '/',
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if (data && data.data) {
			dispatch({
				type: GET_GROUP_INFO_SUCCESS,
				payload: data,
			});
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_GROUP_INFO_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GET_GROUP_INFO_FAIL,
			payload: 'Error fetching site configuration',
		});
		return message;
	}
};

/**
 * Action creator for listing rogue access points.
 *
 * This function asynchronously dispatches actions to fetch a list of rogue access points.
 * It sends a request to the server with a required serial number parameter.
 * Upon a successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {string} serialNumber - required parameter specifying the serial number of the selected group.
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getRogueApList = (serialNumber) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_ROGUE_AP_LIST,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_ROGUE_ACCESS_POINT_API + serialNumber + '/',
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('rogueAPi', config.url);
		console.log('rogue AP list data--->', data);

		if (data && data.data && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: GET_ROGUE_AP_LIST_SUCCESS,
				payload: data,
			});
		} else {
			dispatch({
				type: GET_ROGUE_AP_LIST_FAIL,
				payload: 'Error fetching rogue AP list',
			});
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_ROGUE_AP_LIST_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GET_ROGUE_AP_LIST_FAIL,
			payload: 'Error fetching rogue AP list',
		});
	}
};

export const deleteKnownRogue =
	(serialNumber, payload) => async (dispatch, getState) => {
		try {
			dispatch({
				type: DELETE_KNOWN_ROGUE,
			});

			const jsonData = JSON.stringify(payload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'put',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + ROGUE_KNOWN_DELETE + serialNumber + '/',
				data: ciphertext,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('rogueAPi', config.url);
			console.log('rogue AP list data--->', data);

			if (data && data.data) {
				dispatch({
					type: DELETE_KNOWN_ROGUE_SUCCESS,
					payload: data,
				});
			}
		} catch (error) {
			dispatch({
				type: DELETE_KNOWN_ROGUE_FAIL,
				payload: 'Error deleting known rogue AP',
			});
		}
	};

export const trustUnknownRogue =
	(serialNumber, payload) => async (dispatch, getState) => {
		try {
			dispatch({
				type: MOVE_TO_KWOWN_ROGUE,
			});

			const jsonData = JSON.stringify(payload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + TRUST_ROGUE_TO_KNOWN + serialNumber + '/',
				data: ciphertext,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('rogueAPi', config.url);
			console.log('rogue AP list data--->', data);

			if (data && data.data) {
				dispatch({
					type: MOVE_TO_KWOWN_ROGUE_SUCCESS,
					payload: data,
				});
			}
		} catch (error) {
			dispatch({
				type: MOVE_TO_KWOWN_ROGUE_FAIL,
				payload: 'Error moving to known rogue AP',
			});
		}
	};

export const bulkUploadKnownRogue = (payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: BULK_UPLOAD_KNOWN,
		});

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
			url: ENDPOINT_URL + BULK_KNOWN_ROGUE,
			maxBodyLength: Infinity,
			data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('rogueAPi', config.url);
		console.log('rogue AP list data--->', data);

		if (data && data.data) {
			dispatch({
				type: BULK_UPLOAD_KNOWN_SUCCESS,
				payload: data,
			});
		}
	} catch (error) {
		dispatch({
			type: BULK_UPLOAD_KNOWN_FAIL,
			payload: 'Error uploading bulk known rogue AP list',
		});
	}
};

/**
 * Action creator for listing client cli.
 *
 * This function asynchronously dispatches actions to fetch a list of client cli Entries.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {string} [siteId] - required parameter specifying the site Id of slected group
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getGroupSwitchCongigData =
	(siteId) => async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_SWITCH_TOPOLOGY,
			});

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + GET_SWITCH_TOPOLOGY_API + siteId + '/',
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if (data?.status === 200) {
				dispatch({
					type: GET_SWITCH_TOPOLOGY_SUCCESS,
					payload: data,
				});
				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GET_SWITCH_TOPOLOGY_FAILURE,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GET_GROUP_CONFIGURATION_FAIL,
				payload: 'Error fetching site configuration',
			});
			return message;
		}
	};

export const editSwitchConfig =
	(updatePayload, siteId) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: GET_SWITCH_TOPOLOGY,
			});

			// Configure request
			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				url: ENDPOINT_URL + GET_SWITCH_TOPOLOGY_API + siteId + '/',
				data: ciphertext,
			};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			// Dispatch success action with received data
			if (data?.status === 200) {
				return data;
			}
		} catch (error) {
			// Handle error
			console.error('Failed to edit data', error);
			dispatch({
				type: EDIT_CLI_USERS_COMPLETE,
				payload: error.message || 'Failed to edit data',
			});
			return error;
		}
	};

export const rogueWifiScan = (serialNumber, payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: ROGUE_WIFI_SCAN,
		});
		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			url: ENDPOINT_URL + SCAN_TIP_ROGUE_AP + serialNumber + '/',
			maxBodyLength: Infinity,
			data: ciphertext,
		};
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log("wifi scan data: ", data);
		if (data && data.status && data.status === API_RESPONSE_SUCCESS_STATUS_CODE) {
			dispatch({
				type: ROGUE_WIFI_SCAN_SUCCESS,
				payload: data,
			});
		} else if (data && data?.error) {
			dispatch({
				type: ROGUE_WIFI_SCAN_FAIL,
				payload: data?.error || 'Wifi Scan Failed',
			});
		}
	} catch (error) {
		const errMsg =
			error?.response?.data?.error ||
			error?.response?.data?.message ||
			error?.message ||
			'Wifi Scan Failed';

		dispatch({
			type: ROGUE_WIFI_SCAN_FAIL,
			payload: errMsg,
		});
	}
};

/**
 * Action creator for listing  AP site data.
 *
 * This function asynchronously dispatches actions to fetch a list of AP Site data.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {string} [siteId] - required parameter specifying the site Id of AP group
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getAPGroupInfo = (siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_AP_GROUP_INFO,
		});

		const {
			userLogin: { userInfo },
		} = getState();

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_GROUP_CONFIGURATION_API + siteId + '/',
			headers: {
				'X-Encrypt': 'true',
				'Content-Type': 'application/json',
				Authorization: `${userInfo?.authorizationToken ?? ''}`,
			},
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if (data && data.data) {
			dispatch({
				type: GET_AP_GROUP_INFO_SUCCESS,
				payload: data,
			});
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_AP_GROUP_INFO_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GET_AP_GROUP_INFO_FAIL,
			payload: 'Error fetching site data',
		});
		return message;
	}
};
